export const AdminPSIDailyDashboards = {
  AdminPSIDailyDashboards: 
  {
    permissionsId: '1218d591-95c3-4874-ee40-08da65738802',
  permissionsName: 'Admin PSI Daily',
  componentsId: null,
  components: null
  }
} ;
